import styled from 'styled-components'
import { GREEN, GREY_DARK, GREY_MEDIUM, RED, WHITE } from '../../utils/colors'

type ContainerProps = {
  $error?: boolean;
}

export const Container = styled.div<ContainerProps>`
  margin-bottom: 74px;

  label {
    display: block;
    margin-bottom: 14px;
    color: ${GREY_DARK};
    font-size: 18px;
    line-height: 26px;
  }

  .error {
    margin-bottom: 17px;
    margin-left: 20px;
    font-size: 10px;
    line-height: 12px;
    display: block;
    color: ${RED};
    margin-top: 5px;
  }

  .input_file_content {
    background: ${WHITE};
    border: 1px dashed ${props => props.$error ? RED : GREEN};
    box-sizing: border-box;
    border-radius: 4px;
    min-height: 108px;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
    color: ${props => props.$error ? RED : GREY_MEDIUM};

    input {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      position: absolute;
      cursor: pointer;
    }

    .select {
      display: block;
      position: absolute;
      bottom: 10px;
      left: 0;
      width: 100%;
      font-size: 12px;
      line-height: 26px;
      text-align: center;
      color: #C8C8C8;
      overflow: hidden;
      height: 26px;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0px 20px;
    }
  }
`
